import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import TrashSvg from '@/assets/Trash.svg';

const Trash = ({ size, variant, className }: IconProps) => (
  <img
    src={TrashSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default Trash;
